import gsap from "gsap";
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import EasePack from 'gsap/EasePack';
import CSSPlugin from 'gsap/CSSPlugin';

import 'global/wheel.js';
import audioManager from 'global/audio-manager.js';
audioManager.initialize();


